import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "simple-rename-modal-container" }

import { TranslationProject } from "@medapro-types/TranslationManager/translationManager";
import { setElementFocus } from "@util/focusManager";
import { computed, DeepReadonly, nextTick, ref } from "vue";
import { useI18n } from "vue-i18n";

//#region General

export default /*#__PURE__*/_defineComponent({
  __name: 'RenameTranslationProjectModal',
  props: {
    value: {},
    show: { type: Boolean },
    title: {},
    maxCharactersName: {},
    okButtonText: {},
    translationProjectId: {},
    translationProjects: {}
  },
  emits: ["input", "update:show", "confirm", "cancel"],
  setup(__props: any, { emit: emits }) {

const props = __props;



const internValue = ref<string>("");
const { t: $t } = useI18n();
//#endregion

const localShow = computed({
  get: () => props.show,
  set: (nv) => emits("update:show", nv)
});

const renameInput = ref<any>();

const confirmHandler = () => {
  emits("input", internValue.value);
  emits("confirm", internValue.value);
};

const cancelRename = () => emits("cancel", true);

const hasNameChanged = computed(() => {
  return props.value != internValue.value;
});

const validationFeedbacks = computed(() => {
  const isNameEmpty = internValue.value == "" || internValue.value == null;
  const isDuplicateNameExists =
    internValue.value &&
    props.translationProjects.some(
      (x) => x.name && x.name != "" && x.translationProjectId != props.translationProjectId && x.name.toLowerCase() == internValue.value.toLowerCase()
    );
  const isNameLengthExceeds = internValue.value.length > 128;

  if (isNameEmpty) return $t("validation.valueRequired", { field: $t("name") });
  else if (isDuplicateNameExists)
    return $t("validation.duplicateExists", {
      field: $t("name")
    });
  else if (isNameLengthExceeds)
    return $t("validation.lengthExceeds", {
      field: $t("name", 1),
      length: 256
    });
  else return null;
});

const showHandler = () => {
  internValue.value = props.value;

  //this nextTick and Timeout is necessary because of the modal. If it's not there the focus won't happen.
  nextTick(() => {
    setTimeout(() => {
      const inputHTMLElemnt = renameInput.value?.$el;
      if (inputHTMLElemnt) {
        setElementFocus(inputHTMLElemnt, true);
      }
    }, 100);
  });
};

return (_ctx: any,_cache: any) => {
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: props.title,
    "body-class": "simple-rename-modal-body",
    "header-close-content": "",
    modelValue: localShow.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localShow).value = $event)),
    onOk: confirmHandler,
    onShow: showHandler,
    onCancel: cancelRename
  }, {
    "modal-footer": _withCtx(({ ok, cancel }) => [
      _createVNode(_component_b_btn, {
        onClick: ok,
        variant: "primary",
        disabled: validationFeedbacks.value || !hasNameChanged.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.okButtonText), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "disabled"]),
      _createVNode(_component_b_btn, { onClick: cancel }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref($t)("Cancel")), 1)
        ]),
        _: 2
      }, 1032, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_b_form_group, { label: "Name" }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_b_input, {
              max: _ctx.maxCharactersName,
              modelValue: internValue.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internValue).value = $event)),
              class: _normalizeClass({ 'border-danger': validationFeedbacks.value }),
              ref_key: "renameInput",
              ref: renameInput,
              onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
            () => {
              confirmHandler();
              localShow.value = false;
            }
          , ["prevent"]), ["enter"]))
            }, null, 8, ["max", "modelValue", "class"]), [
              [_directive_tooltip, validationFeedbacks.value]
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})